<div class="mx-auto 2xl:max-w-screen-2xl p-6">
<h1>Privacy Policy</h1>
<h2>INFORMATIVA SULLA PRIVACY AI SENSI DEGLI ARTT. 13 E 14 DEL REGOLAMENTO (UE) 2016/679 (GDPR)</h2>
<h3>Premessa</h3>
La presente informativa è resa ai sensi degli artt. 13 e 14 del <strong>Regolamento (UE) 2016/679</strong> (“GDPR”) e descrive le modalità e le finalità del trattamento dei dati personali effettuato da <strong>4T INSURTECH S.R.L.</strong>, in relazione all’utilizzo dei siti e delle piattaforme online <strong><a href="https://www.tutelapatente.it">www.tutelapatente.it</a></strong> e <strong><a href="https://app.tutelapatente.it/">https://app.tutelapatente.it/</a></strong> (di seguito, congiuntamente, “Piattaforma”).
<ol>
 	<li>
<h3>Titolare del Trattamento</h3>
</li>
</ol>
Il Titolare del trattamento è:
<strong>4T INSURTECH S.R.L.</strong>
Sede legale: <strong>Via Gazzoletto, 4C - 26100 Cremona (CR)</strong>
P.IVA: <strong>IT10566580964</strong>
Iscritta al RUI con numero <strong>B000616198</strong>
Email: <strong><a href="mailto:i4m@legalmail.it">i4m&#64;legalmail.it</a></strong>
<ol start="2">
 	<li>
<h3>Finalità del Trattamento</h3>
</li>
</ol>
I dati personali raccolti tramite la Piattaforma saranno trattati per le seguenti finalità:
<ol>
 	<li><strong>Esecuzione dei servizi richiesti</strong>, tra cui:</li>
</ol>
<ul>
 	<li>Stipula e gestione di <strong>polizze assicurative di tutela legale</strong> per aziende;</li>
 	<li>Valutazione e comparazione delle offerte delle compagnie partner;</li>
 	<li>Comunicazioni precontrattuali e contrattuali con l'azienda cliente.</li>
</ul>
<ol>
 	<li><strong>Adempimenti legali e fiscali</strong>, connessi alla stipula e alla gestione dei rapporti contrattuali.</li>
 	<li><strong>Attività di marketing</strong> e comunicazione commerciale, previo consenso dell’interessato, finalizzate all’invio di materiale informativo o promozionale su prodotti assicurativi, anche mediante strumenti automatizzati (email, sms, newsletter).</li>
 	<li><strong> Base giuridica del trattamento</strong></li>
</ol>
Il trattamento dei dati personali si fonda sulle seguenti basi giuridiche:
<ul>
 	<li><strong>Esecuzione di un contratto o di misure precontrattuali</strong> (art. 6, par. 1, lett. b GDPR);</li>
 	<li><strong>Adempimento di obblighi legali</strong> (art. 6, par. 1, lett. c GDPR);</li>
 	<li><strong>Consenso dell'interessato</strong> per attività di marketing facoltative (art. 6, par. 1, lett. a GDPR);</li>
 	<li><strong>Legittimo interesse del titolare</strong> in relazione alla gestione e miglioramento dei propri servizi (art. 6, par. 1, lett. f GDPR).</li>
</ul>
<ol start="4">
 	<li>
<h3>Natura del conferimento</h3>
</li>
</ol>
Il conferimento dei dati personali è <strong>necessario</strong> per la stipula delle polizze assicurative e la gestione del rapporto contrattuale.
Il mancato conferimento comporterà l'impossibilità di erogare i servizi richiesti.
Il conferimento dei dati per finalità di marketing è invece <strong>facoltativo</strong> e l'eventuale rifiuto non pregiudica la fruizione dei servizi principali.
<ol start="5">
 	<li>
<h3>Modalità di trattamento e conservazione</h3>
</li>
</ol>
Il trattamento avverrà con modalità <strong>manuali e automatizzate</strong>, nel rispetto dei principi di correttezza, liceità e trasparenza, e delle misure di sicurezza previste dall’art. 32 del GDPR.

I dati saranno conservati per un periodo di tempo non superiore al necessario per il raggiungimento delle finalità per le quali sono raccolti, e comunque nel rispetto dei termini di legge o contrattuali.
Al termine del periodo di conservazione, i dati saranno cancellati o anonimizzati.
<ol start="6">
 	<li>
<h3>Ambito di comunicazione dei dati</h3>
</li>
</ol>
I dati personali potranno essere comunicati esclusivamente a:
<ol>
 	<li><strong>Compagnie assicurative partner</strong>, per la finalità di stipula e gestione delle polizze;
b. <strong>Società di servizi informatici</strong>e <strong>fornitori tecnici</strong>, per la manutenzione della Piattaforma;
c. <strong>Consulenti fiscali e legali</strong>, per adempimenti amministrativi e contabili;
d. <strong>Società di marketing e comunicazione</strong>, per attività promozionali svolte in nome e per conto del Titolare (solo previo consenso dell’interessato).</li>
</ol>
I dati non saranno diffusi né trasferiti al di fuori dello Spazio Economico Europeo senza adeguate garanzie di conformità al GDPR.
<ol start="7">
 	<li>
<h3>Soggetti autorizzati al trattamento</h3>
</li>
</ol>
Potranno venire a conoscenza dei dati:
<ul>
 	<li>I <strong>dipendenti</strong> e <strong>collaboratori</strong> del Titolare, debitamente istruiti e autorizzati al trattamento;</li>
 	<li>Gli eventuali <strong>Responsabili esterni del trattamento</strong>, nominati ai sensi dell’art. 28 GDPR.</li>
</ul>
<ol start="8">
 	<li>
<h3>Diritti dell'interessato (artt. 15-22 GDPR)</h3>
</li>
</ol>
L'interessato può esercitare in qualsiasi momento i seguenti diritti:

a. <strong>Accesso</strong>ai propri dati personali;
b. <strong>Rettifica</strong> dei dati inesatti o <strong>integrazione</strong> di quelli incompleti;
c. <strong>Cancellazione</strong> dei dati personali (“diritto all'oblio”);
d. <strong>Limitazione</strong> del trattamento;
e. <strong>Portabilità</strong> dei dati a un altro titolare;
f. <strong>Opposizione</strong> al trattamento, in particolare per finalità di marketing;
g. <strong>Reclamo</strong> all'Autorità Garante per la protezione dei dati personali (<a href="https://www.garanteprivacy.it">www.garanteprivacy.it</a>).

Le richieste possono essere inviate al seguente indirizzo: <strong><a href="mailto:i4m@legalmail.it">i4m&#64;legalmail.it</a></strong>
<ol start="9">
 	<li>
<h3>Sicurezza dei dati</h3>
</li>
</ol>
Il Titolare adotta misure di sicurezza tecniche e organizzative adeguate per proteggere i dati da accessi non autorizzati, perdita o divulgazione, tra cui:
<ul>
 	<li>Comunicazioni cifrate tramite protocollo <strong>SSL</strong>;</li>
 	<li>Firewall e sistemi di monitoraggio anti-intrusione;</li>
 	<li>Accessi controllati ai dati aziendali e procedure di backup sicuro.</li>
</ul>
<ol start="10">
 	<li>
<h3>Modifiche alla presente informativa</h3>
</li>
</ol>
Il Titolare si riserva il diritto di modificare o aggiornare la presente informativa in qualsiasi momento.
La versione più recente sarà sempre disponibile sul sito <a href="https://app.tutelapatente.it/privacy-policy/">https://app.tutelapatente.it/privacy-policy/</a>.
<br>
<strong>Ultimo aggiornamento:</strong> ottobre 2025
<br>
<strong>Titolare del trattamento:</strong> <em>4T Insurtech S.r.l.</em>
<br>
<strong>Sede legale:</strong> Via Gazzoletto, 4C - 26100 Cremona
<br>
<strong>Email:</strong> <a href="mailto:i4m@legalmail.it">i4m&#64;legalmail.it</a>

</div>
